import { render, staticRenderFns } from "./HomeTips.vue?vue&type=template&id=6dae627b&"
import script from "./HomeTips.vue?vue&type=script&lang=js&"
export * from "./HomeTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports